import { Game } from "@aura-frontend/omnibus-az-client";

/**
 * Generates a standardized filename for game CSV downloads
 * Format: {date}_{time}_{gameName}.csv
 * Example: 11-17-2025_02-30PM_TeamA-vs-TeamB.csv
 *
 * @param game - The game object containing metadata
 * @returns Formatted filename string
 */
export function generateGameCsvFilename(game: Game): string {
  const timeData = game.times?.[0] as
    | { start_time?: number; startTime?: number }
    | undefined;
  const startTimeSeconds = timeData?.start_time ?? timeData?.startTime ?? 0;
  const startTime = new Date(Number(startTimeSeconds) * 1000);
  const isValidDate = !isNaN(startTime.getTime());

  const dateStr = isValidDate
    ? startTime.toLocaleDateString().replace(/\//g, "-")
    : "unknown-date";

  const timeStr = isValidDate
    ? startTime
        .toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
        .replace(/:/g, "-")
        .replace(/\s([AP]M)/, "$1")
    : "unknown-time";

  const gameName = game.displayName ?? "game";

  return `${dateStr}_${timeStr}_${gameName}.csv`;
}
